


















import moment, { unitOfTime } from 'moment'

import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import PaceMaker from './PaceMaker.vue'

interface UnitScale {
  greater: unitOfTime.Base | null
  smaller: unitOfTime.Base | null
  value: number
}

@Component({
  components: {
    PaceMaker
  }
})
export default class RelativeTime extends Vue {
  @Prop({ type: String, default: 'span' })
  readonly tag!: string

  @Prop({ type: Date, required: true })
  readonly date!: Date

  @Prop({ type: Boolean, default: true })
  readonly optimize!: boolean

  @Prop({ type: Boolean, default: true })
  readonly prefix!: boolean

  @Prop({ type: String, default: 'minute' })
  readonly smallerUnit!: unitOfTime.Base

  now = moment()

  unit: unitOfTime.Base = 'minute'

  get unitScale () {
    const units: Record<string, UnitScale> = {
      year: {
        greater: null,
        smaller: 'month',
        value: 12
      },
      month: {
        greater: 'year',
        smaller: 'day',
        value: 30
      },
      day: {
        greater: 'month',
        smaller: 'hour',
        value: 24
      },
      hour: {
        greater: 'day',
        smaller: 'minute',
        value: 60
      },
      minute: {
        greater: 'hour',
        smaller: 'second',
        value: 60
      },
      second: {
        greater: 'minute',
        smaller: 'millisecond',
        value: 1000
      },
      millisecond: {
        greater: 'second',
        smaller: null,
        value: 0
      }
    }

    return units[moment.normalizeUnits(this.unit)]
  }

  @Watch('now', { immediate: true })
  onNowChange () {
    if (!this.optimize) {
      return
    }

    const diff = this.now.diff(moment(this.date), this.unit)

    if (
      this.unitScale.greater && (
        diff >= this.unitScale.value - 1 ||
        diff <= this.unitScale.value * -2 + 1
      )
    ) {
      this.unit = this.unitScale.greater
    } else if (
      this.unitScale.smaller &&
      this.unit !== this.smallerUnit &&
      (diff === -1 || diff === 0)
    ) {
      this.unit = this.unitScale.smaller
    }
  }
}
